module.exports = __webpack_public_path__ + "img/ico-edit.6338b016.svg";